<template lang="html">
  <modal
    name="alert-success-modal"
    width="394"
    height="auto"
    :adaptive="true"
    :maxWidth="416"
    class="symbium-modal"
    @opened="open"
  >
    <div class="lightbox-alert">
      <div class="si-check lightbox-alert-icon"></div>
      <div class="lightbox-alert-title" v-if="title">{{ title }}</div>
      <div class="lightbox-alert-message" v-if="message">{{ message }}</div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
    },
    title: {
      type: String,
    },
    autoCloseTime: {
      type: Number,
      default: 1500,
    },
  },
  methods: {
    open() {
      setTimeout(() => {
        this.$modal.hide('alert-success-modal')
      }, this.autoCloseTime)
    },
  },
}
</script>

<style lang="scss">
.symbium-modal {
  background: rgba(0, 0, 0, 0.6) !important;

  .v--modal {
    border-radius: 16px !important;
    background-color: white !important;
  }

  .lightbox-alert {
    padding: 24px;
  }
}
</style>
